import setDatetimeLocale from 'lib/toolkit/behaviors/format_datetimes.js.coffee'

export default class LocalizeView extends Backbone.View
  events:
    "change select"       : "setLanguageFromDropdown"

  initialize: (options) ->
    @currentLanguage = $.macaroon("preferred_lang") || "en"
    @userPrefs = options.userPrefs
    @enabled = options.enabled
    @availableLangs = ["en"]
    @newLanguageSet = false
    @localizeSelect = @$el.find("select")

    if @enabled

      # To prevent browser extensions from adding text, we  add a class to #page-container and target
      # *only* that class for translation (since extensions usually append text to the body)
      $("#page-container").addClass("js-translate-root")

      # In dev and qa0, add user names as labels to pending phrases
      if options.includeUserLabels && page.has("currentUser")
        $("#page-container").attr("data-localize", page.get("currentUser").email)

      @initLocalize(options)

      # Grab available languages from localize to cross-check w/ user's preferred lang (and browser's accept-lang)
      Localize.getAvailableLanguages @availableLanguages
      setDatetimeLocale(@currentLanguage)
    else
      @setupSelect2()

  initLocalize: (options) ->
    # Initialize with currentLanguage if one was saved, else just use en-US till we can choose preferred below
    # NOTE - using our own "remember language" logic, to support dynamically added langs
    Localize.initialize
      key: options.apiKey
      targetLanguage: @currentLanguage
      translateMetaTags: false
      translateAlt: false
      translateBody: false
      rememberLanguage: false
      autodetectLanguage: false
      saveNewPhrases: options.saveNewPhrases
      saveNewPhrasesFromSource: true
      translateClasses: ["js-translate-root"]
      blockedClasses: [
        "ui-datepicker",
        "ui-timepicker-wrapper",
        "filter-collapse",
        "textoverlay",
        "file-name",
        "file-size",
        "intercom-app"
      ]

  availableLanguages: (err, languages) =>
    return console.log("Localize ERR:", err) && @setupSelect2() if err

    # Update selection items available in dropdown
    $optgroup = $("<optgroup/>").appendTo @localizeSelect
    for lang in languages
      continue if lang.code == "en" # English is in select by default

      @availableLangs.push lang.code
      option = $("<option/>").attr({value: lang.code, notranslate: true}).text(lang.name)
      $optgroup.append option

    if !@currentLanguage
      # If there was not a language set, check available languages against user's preferred
      # and set new currentLanguage for future translations (and retranslate if there should be a change)
      for prefLang in @userPrefs
        available = _.find languages, (l) -> l.code == prefLang
        if available
          @setPreferredLanguage prefLang
          break

    @setupSelect2()

  setupSelect2: ->
    @updateDropdownSelection()
    contently.ui.setup_select2(@)

  updateDropdownSelection: =>
    langVal  =  @currentLanguage || "en"
    return if langVal not in @availableLangs
    @localizeSelect.val(langVal).trigger("change")

  setLanguageFromDropdown: (e) =>
    selectedLanguage = @localizeSelect.val()
    return if @currentLanguage == selectedLanguage
    @setPreferredLanguage selectedLanguage
    if @newLanguageSet
      # because re-translating is unreliable, reload the page for a fresh
      # translation with the selected language
      location.reload()
    else
      @newLanguageSet = true
      @currentLanguage = selectedLanguage
      Localize.setLanguage selectedLanguage
      setDatetimeLocale(selectedLanguage)

  setPreferredLanguage: (lang) ->
    oneYear = 31540000000
    $.macaroon("preferred_lang", lang, { path: "/", expires: oneYear })



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/localize_view.coffee